import React, { memo, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import TableCDS from '@sharedCR/coreDesignSystem/Table/TableCDS';
import PropTypes from 'prop-types';

import { StatusEnum } from 'constants/status';

import InlineNotice from '../../../components/InlineNotice';
import { formatMoney } from '../../../Construction.utils';
import { sectionStyles, sectionTitleStyles } from '../../DrawReviewDrawer.styles';
import { DrawReviewDrawerTestIds } from '../../DrawReviewDrawer.testIds';

import { getLineItemsConfig } from './DrawLineItemsSection.config';

const DrawLineItemsSection = ({ lineItems }) => {
  const config = useMemo(() => getLineItemsConfig(), []);
  const overRemainingLine = useMemo(
    () => lineItems.find(line => line.isOverRemaining) ?? null,
    [lineItems],
  );

  return (
    <Box data-testid={DrawReviewDrawerTestIds.LINE_ITEMS_SECTION} sx={sectionStyles}>
      <Typography sx={sectionTitleStyles} variant="bold12">
        {`Line Items (${lineItems.length} cost codes)`}
      </Typography>
      <TableCDS config={config} data={lineItems} title="" />
      {overRemainingLine && (
        <InlineNotice
          dataTestId={DrawReviewDrawerTestIds.LINE_ITEMS_OVER_REMAINING_ALERT}
          variant={StatusEnum.WARNING}
        >
          <strong>{overRemainingLine.category}</strong>
          {' requested '}
          <strong>{formatMoney(overRemainingLine.requested)}</strong>
          {' against '}
          <strong>{formatMoney(overRemainingLine.budgetRemaining)}</strong>
          {' remaining — exceeds this line by '}
          <strong>{formatMoney(overRemainingLine.overRemainingAmount)}</strong>. Approval requires a
          reallocation or a reduced draw amount.
        </InlineNotice>
      )}
    </Box>
  );
};

DrawLineItemsSection.propTypes = {
  lineItems: PropTypes.array.isRequired,
};

export default memo(DrawLineItemsSection);
